import { Box, CircularProgress } from "@mui/material";

export const LoadingSpinner = () => (
  <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
    <CircularProgress color="inherit" size="2rem" />
  </Box>
);
